import {Injectable} from '@angular/core';
import {UserContext} from './user-context';
import {ManagedLocaleService} from '../managed-locale.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {DomainUrlService} from '../../config/domain-url.service';
import {User} from '../../../domain/core/model/user';
import {LocalStorageKeyEnum} from '../local-storage-key.enum';
import {getParameterByName} from '../../config/url.util';
import {AuthenticationService} from '../../security/authentication.service';


@Injectable({
              providedIn: 'root'
            })
export class UserContextService {

  constructor(private httpClient: HttpClient,
              private domainUrlService: DomainUrlService,
              private authenticationService: AuthenticationService) {
  }

  private userContext: UserContext | undefined;

  initUserContextFromLoggedUser(): Observable<UserContext> {
    const localeUrlParam = getParameterByName('locale');
    const locale = ManagedLocaleService.getSimplifiedLocaleOrFrByDefault(localeUrlParam ? localeUrlParam : navigator.language);
    return this.getAccountId()
               .pipe(mergeMap(accountId => this.initUserContextForAccountId(accountId, locale)));
  }

  getUserContext(): UserContext {
    return this.userContext as UserContext;
  }

  private getAccountId(): Observable<string> {
    const accountIdFromParam = getParameterByName('accountId');
    if (accountIdFromParam) {
      localStorage.setItem(LocalStorageKeyEnum.ACCOUNT_ID, accountIdFromParam);
      return of(accountIdFromParam);
    }
    const accountIdFromLocalStorage = localStorage.getItem(LocalStorageKeyEnum.ACCOUNT_ID);
    if (accountIdFromLocalStorage) {
      return of(accountIdFromLocalStorage);
    }
    return this.httpClient.get<any>(`${this.domainUrlService.getOptimPortalBackApiUrl()}/rest/public/v1/user/default-account-id`)
               .pipe(map(result => result.userDefaultAccountId),
                     catchError(err => of(this.authenticationService.logout())));
  }

  private initUserContextForAccountId(accountId: string, locale: string): Observable<UserContext> {
    const headers = new HttpHeaders().set('accountId', accountId);
    const params = new HttpParams().set('accountId', accountId);
    return this.httpClient
               .get<User>(`${this.domainUrlService.getOptimPortalBackApiUrl()}/rest/public/v1/account/user`, {params, headers})
               .pipe(map((user: User) => this.initUserContext(user, accountId, locale)));
  }

  private initUserContext(user: User, accountId: string | null, locale: string): UserContext {
    const newAccountId = accountId ? accountId : this.getDefaultAccountId(user);
    this.userContext = new UserContext(newAccountId, user, locale);
    return this.userContext;
  }

  private getDefaultAccountId(user: User): string {
    let currentAccount = user.accounts.find(acc => acc.isDefault);
    if (currentAccount == null) {
      currentAccount = user.accounts[0];
    }
    return currentAccount.accountId;
  }

}
